import { combineReducers } from 'redux';
import { tagsBadgesListReducer } from './TagsBadgesListReducer';

export const tagsBadgesReducer = combineReducers({
  tagsBadgesList: tagsBadgesListReducer,
});
